import React from 'react';

const Loader = () => {
    return (
        <>
            <div className="z-30 w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin">
            </div>
        </>
    )
}

export default Loader;